import React, { useState } from 'react';
import './Highlights.css';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Fab from '@material-ui/core/Fab';
import ListSubheader from '@material-ui/core/ListSubheader';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { trackHighlightsPanelOpen } from '../../utils/analytics';
import { isHighlightRecord, isRenderableHighlight } from '../../utils/highlights';

const drawerWidth = 350;

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: 1100
  },
  drawer: {
    width: drawerWidth,
    flexGrow: 0,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }
}));

export default function Highlights(props) {
  const classes = useStyles();
  const { highlights, deleteHighlight, textbookId, textbookTitle } = props;
  const [open, setOpen] = useState(false);
  const savedHighlights = Array.isArray(highlights) ? highlights.filter(isHighlightRecord) : [];

  const updateHash = highlight => {
    window.location.hash = `highlight-${highlight.id}`;
  };

  const openDrawer = (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    trackHighlightsPanelOpen(textbookId, textbookTitle);
    setOpen(true);
  };

  const closeDrawer = (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setOpen(false);
  };

  return (
    <div>
      <Fab className={classes.fab} size="small" color="secondary" aria-label="Toggle Highlights" onClick={openDrawer}>
        <NoteAddIcon />
      </Fab>
      <Drawer anchor="right" open={open} onClose={closeDrawer}>
        <ListSubheader component="div" id="nested-list-subheader">
          Highlights
        </ListSubheader>
        <ul className="SidebarHighlights">
          {savedHighlights.map(highlight => {
            const canNavigate = isRenderableHighlight(highlight);
            const quote = typeof highlight.content?.text === 'string' ? highlight.content.text : '';
            const note = typeof highlight.comment?.text === 'string' ? highlight.comment.text : '';
            const image = typeof highlight.content?.image === 'string' ? highlight.content.image : '';

            return (
              <li
                key={highlight.id}
                className="sidebar__highlight"
                onClick={canNavigate ? () => {
                  updateHash(highlight);
                } : undefined}
              >
                <div>
                  {quote ? (
                    <blockquote className="HighlightQuote">
                      {`${quote.slice(0, 90).trim()}…`}
                    </blockquote>
                  ) : null}
                  <p>{note}</p>
                  {!canNavigate && (
                    <p className="highlight__location-unavailable">
                      This highlight’s location is unavailable. Select the text again to recreate the highlight. Your note is preserved here.
                    </p>
                  )}
                  {image
                    ? (
                        <div
                          className="highlight__image"
                          style={{ marginTop: "0.5rem" }}
                        >
                          <img src={image} alt={"Screenshot"} />
                        </div>
                      )
                    : null
                    }
                  <div>
                    <button onClick={event => {
                      event.stopPropagation();
                      deleteHighlight(highlight);
                    }}>
                      Delete
                    </button>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </Drawer>
    </div>
  );
}
